<template>

</template>

<script>
  export default {
      mounted(){
          this.$store.dispatch('currentUser/logoutUser')
          location.href = '/login'
      }
  }
</script>